import { Component, OnInit, OnDestroy } from '@angular/core'; 
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { ChildrenSelectorComponent, Student } from '../../shared/children-selector/children-selector.component';
import { NoteService, Note, ApiResponseNotes } from '../../services/note.service';
import { NotificationService } from '../../services/notification.service';
import { TranslatePipe } from '@ngx-translate/core';
import { PageTitleComponent } from "../../shared/page-title/page-title.component";
import { LoaderComponent } from "../../shared/loader/loader.component";
import { Subject, takeUntil, forkJoin } from 'rxjs';



@Component({
  selector: 'app-note',
  standalone: true,
  imports: [CommonModule, TableModule, InputTextModule, ButtonModule, FormsModule, ChildrenSelectorComponent, TranslatePipe, PageTitleComponent, LoaderComponent],

  templateUrl: './note.component.html',
  styleUrls: ['./note.component.css']
})
export class NoteComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  selectedStudentId!: number;
  selectedBatchId!: number;
  selectedUserId!: number;
  selectedOrgId!: number;
  selectedChild!: string;

  notes: Note[] = [];
  filteredNotes: Note[] = [];
  loading = false;
  searchValue: string = '';

  constructor(
    private noteService: NoteService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onStudentSelected(student: Student): void {
    this.selectedChild = student.nameStudent;
    this.selectedStudentId = student.idStudent;
    this.selectedBatchId = student.batchId;
    this.selectedUserId = student.idUserStudent;
    this.selectedOrgId = student.idOrg; // <- utilisez idOrg ici
    this.loadNotes();
  }

  loadNotes(): void {
  if (!this.selectedStudentId || !this.selectedBatchId || !this.selectedUserId || !this.selectedOrgId) return;

  this.loading = true;

  this.noteService.getNotes(this.selectedStudentId, this.selectedOrgId)
    .subscribe({
      next: (data: ApiResponseNotes) => {
        this.notes = (data.response || []).map((note: Note) => ({
          ...note,
          creationDate: note.creationDate?.split(' ')[0] || ''
        }));

        this.filteredNotes = [...this.notes]; // initialiser filteredNotes
        this.loading = false;

        // Mark note notifications as seen after loading data
        this.markNoteNotificationsAsSeen(this.notes);
      },
      error: (err) => {
        console.error('Erreur API notes:', err);
        this.loading = false;
      }
    });
}

  private markNoteNotificationsAsSeen(noteRecords: Note[]): void {
    if (!this.selectedStudentId) return;
    
    const unseen = (noteRecords || []).filter(n => (n as any).vu !== '1' && !!n.id);

    if (unseen.length === 0) {
      this.updateNotificationCounts();
      return;
    }

    const updates$ = unseen.map(note =>
      this.notificationService.updateNotificationStatus({
        idType: note.id,
        idStudent: this.selectedStudentId,
        nameType: 'Examen'
      })
    );

    // Execute all updates then refresh counts once
    forkJoin(updates$)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          console.log(`Marked ${unseen.length} note notifications as seen`);
          this.updateNotificationCounts();
        },
        error: (err) => {
          console.error('Error updating one or more note notifications:', err);
          // Even if some fail, try to refresh counts to reflect partial success
          this.updateNotificationCounts();
        }
      });
  }

  private updateNotificationCounts(): void {
    // Get userData from localStorage to access iduser
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    if (userData.iduser) {
      this.notificationService.getNotificationCounts(userData.iduser)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (counts) => {
            // Update the notification counts in the service or emit to parent components
          },
          error: (err) => console.error('Error updating notification counts:', err)
        });
    }
  }

  onSearchChange(): void {
    const val = this.searchValue.toLowerCase();
    this.filteredNotes = this.notes.filter(note =>
      (note.creationDate || '').toLowerCase().includes(val) ||
      (note.examName || '').toLowerCase().includes(val) ||
      (note.description || '').toLowerCase().includes(val) ||
      (note.noteMax || '').toLowerCase().includes(val) ||
      (note.noteMin || '').toLowerCase().includes(val)
    );
  }
}
